import React from 'react';
import { Modal, Button } from 'antd';

const ConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
    return (
        <Modal
            title="Confirm Deletion"
            visible={isOpen}
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>,
                <Button key="confirm" type="primary" onClick={onConfirm}>
                    Delete
                </Button>,
            ]}
        >
            <p>Are you sure you want to delete this item?</p>
        </Modal>
    );
};

export default ConfirmationModal;